import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../ui/Button'
import WarningModal from '../IssueStatuses/WarningModal'

const BODY_CLASS = 'tw:m-0! tw:text-base tw:text-gray-500 tw:text-center'

const ConfirmRemoveFileModal = ({ isOpen, onCancel, onConfirm }) => {
  const footer = (
    <>
      <Button variant="neutral" onClick={onCancel}>Annuler</Button>
      <Button variant="danger" onClick={onConfirm}>Supprimer</Button>
    </>
  )

  return (
    <WarningModal footer={footer} isOpen={isOpen} title="Suppression de la photo" onClose={onCancel}>
      <p className={BODY_CLASS}>
        Cette photo sera définitivement supprimée lors de l’enregistrement de l’alerte.
      </p>
    </WarningModal>
  )
}

ConfirmRemoveFileModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ConfirmRemoveFileModal
